import { useFadeUp } from '../hooks/usefadeup'
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa'
import './ContacteNos.css'

const contactInfo = [
  {
    icon: FaMapMarkerAlt,
    title: 'Endereço',
    details: ['Rua do Rio Inhamiara, Golf Residence, Maputo'],
  },
  {
    icon: FaPhone,
    title: 'Telefone',
    details: ['+258 84 263 2727'],
  },
  {
    icon: FaEnvelope,
    title: 'Email',
    details: ['info@makhowo.co.mz'],
  },
  {
    icon: FaClock,
    title: 'Horário',
    details: ['Seg-Sex: 8h-17h'],
  },
]

export default function ContacteNos() {
  const ref = useFadeUp<HTMLElement>()

  return (
    <section id="contactenos" className="cn" ref={ref}>
      <div className="cn-header" data-fade data-fade-delay="0">
        <h2 className="cn-title">Contactos</h2>
      </div>

      <div className="cn-grid">
        {contactInfo.map(({ icon: Icon, title, details }, i) => (
          <div
            key={title}
            className="cn-card"
            data-fade
            data-fade-delay={`${120 + i * 80}`}
          >
            <div className="cn-card-icon" aria-hidden="true">
              <Icon />
            </div>
            <h3 className="cn-card-title">{title}</h3>
            {details.map((detail, j) => (
              <p key={j} className="cn-card-detail">{detail}</p>
            ))}
          </div>
        ))}
      </div>
    </section>
  )
}